import { useCallback, useEffect, useState } from 'react'
import styled from '@emotion/styled'
import {
  selectCurrentItem,
  setCurrentItem,
  closeModal,
  useAppDispatch,
  useAppSelector,
} from '@open-tender/cloud'
import { MenuItem } from '..'
import { CartItem } from '@open-tender/types'

const ItemModalView = styled.div`
  position: relative;
  width: 90%;
  max-width: ${(props) => props.theme.item.desktop.maxWidth};
  height: 90%;
  overflow: hidden;
  background-color: ${(props) => props.theme.bgColors.primary};
  border-radius: ${(props) => props.theme.border.radius};
  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    width: 100%;
    max-width: ${(props) => props.theme.item.mobile.maxWidth};
    height: 100%;
    border-radius: 0;
  }
`

const ItemModalContent = styled.div`
  padding: 0;
  height: 100%;
  overflow: hidden;
`

interface ItemModalProps extends Record<string, unknown> {
  cartItem?: CartItem
  isInUpsell?: boolean
  addCallback?: () => void
}

const ItemModal = ({ cartItem, isInUpsell, addCallback }: ItemModalProps) => {
  const dispatch = useAppDispatch()
  const currentItem = useAppSelector(selectCurrentItem)
  const item = cartItem || currentItem
  const [imageUrl, setImageUrl] = useState(item ? item.imageUrl : null)
  const imageUrlWithFallback = (imageUrl || item?.imageUrl) ?? null

  const cancel = useCallback(() => {
    dispatch(closeModal())
    if (!isInUpsell) {
      setTimeout(() => {
        dispatch(setCurrentItem(null))
      }, 275)
    }
  }, [dispatch, isInUpsell])

  useEffect(() => {
    if (item?.imageUrl) {
      setImageUrl(item.imageUrl)
    }
  }, [item?.imageUrl])

  if (!item) return null

  return (
    <ItemModalView>
      <ItemModalContent role="dialog" aria-labelledby="dialogTitle">
        <MenuItem
          cancel={cancel}
          imageUrlWithFallback={imageUrlWithFallback}
          setImageUrl={setImageUrl}
          currentItem={item}
          isInUpsell={isInUpsell}
          addCallback={addCallback}
        />
      </ItemModalContent>
    </ItemModalView>
  )
}

export default ItemModal
